<template>

  <div class="horiz-box">
    <div class="avatar alt"></div>
  </div>

  <div class="fancy-box bio">
    <p>
      My name is Adrian Marple (aka Marplebot), and I've been making games since 2018. I focus on the amorphous space around experimental, logical, and cooperative games, games that are often elegant and with a minimum of violence.
    </p>
    <p>
      Check out the <a href="/games">Games I'm working on</a> or if you want more detail, feel free to read <a href="/blog">my old posts</a>. Or if you want to hear future posts signup for the old mailing list below.
    </p>
    <p>
      If you want to contact me directly:
      <ul>
        <li>Email: adrian@marplebot.com (preferred)</li>
        <li>Twitter: <a href="https://twitter.com/marplebot">@marplebot</a></li>
      </ul>
    </p>
  </div>

  <div class="horiz-box"></div>
  <div class="horiz-box"></div>
  <Signup/>
</template>

<script>
import Signup from "@/components/Signup"

export default {
  name: 'Home',
  components: { Signup },
}
</script>

<style>
.bio {
  padding: 0 24px;
  box-sizing: border-box;
  font-size: 2.5em;
}
.bio a {
  text-decoration: underline;
}
</style>
